import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const solutions = [
  { title: "Profiles that show what actually matters", detail: "Founders share traction, stage, and sector. Investors define their thesis. No fluff, no guesswork." },
  { title: "Smart filtering so you only see people who fit", detail: "Our matching engine surfaces opportunities based on investment alignment, not who paid for a sponsored slot." },
  { title: "Browse deals in minutes, not months", detail: "Swipe-style discovery lets both sides make quick, deliberate decisions without the back-and-forth." },
  { title: "Conversations that only start when both sides say yes", detail: "Mutual interest unlocks the chat. No unwanted cold messages, no awkward intros." },
];

const SolutionSection = () => {
  return (
    <section className="py-10 md:py-14 section-teal" aria-label="How AdV3nture solves fundraising">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <p className="text-xs font-medium text-primary/80 uppercase tracking-widest mb-3">The Solution</p>
            <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4 text-foreground">
              We built what fundraising{" "}
              <span className="text-gradient">should have been from the start</span>
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto">
              AdV3nture replaces the chaos of cold outreach with a clean, structured process designed for the way early-stage investing actually works.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-4">
            {solutions.map((solution, i) => (
              <motion.div
                key={solution.title}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="rounded-xl bg-card/70 backdrop-blur-xl p-5 transition-all duration-300 hover:bg-card/90 teal-ring-hover"
                style={{ border: "1px solid hsl(174 65% 45% / 0.15)", borderLeftWidth: "2px", borderLeftColor: "hsl(174 65% 45% / 0.55)" }}
              >
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="w-4 h-4 text-primary shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm font-semibold text-foreground mb-1 leading-snug">{solution.title}</p>
                    <p className="text-xs text-muted-foreground leading-relaxed">{solution.detail}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
